import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';
import JSCookie from 'js-cookie';

export default new class {

    constructor() {
        this.userFrontendDataRequest = undefined;
        this.userFrontendData = undefined;
    }

    async getTime() {
      return ServerRequestUtil.post('/api/app/studies/gettime');
    }
    
    async getCategory() {
      return ServerRequestUtil.post('/api/app/studies/datas');
    }
    async getCategorySingle(id) {
	    var data = {id:id}
	    
      return ServerRequestUtil.post('/api/app/studies/datas', data);
    }
    
    async getHtml(url) {
	    var data = {url:url}
	    
      return ServerRequestUtil.post('/api/app/studies/game', data);
    }
}
